import React from 'react';
import PropTypes from 'prop-types';
import { Media } from 'react-breakpoints';

const MediaBreakpoint = ({ from, to, children }) => (
  <Media>
    {({ breakpoints, currentBreakpoint }) =>
      (from ? breakpoints[currentBreakpoint] >= from : true) && (to ? breakpoints[currentBreakpoint] < to : true) && children
    }
  </Media>
);

MediaBreakpoint.propTypes = {
  from: PropTypes.number,
  to: PropTypes.number,
  children: PropTypes.node.isRequired,
};

MediaBreakpoint.defaultProps = {
  from: undefined,
  to: undefined,
};

export default MediaBreakpoint;
